import axios from '@/plugins/axios';

export const MAINTAINCE = '/health';

export async function maintaince() {
  try {
    const { data } = await axios.get(MAINTAINCE);
    return data;
  } catch (error) {
    return { error };
  }
}
